import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import EmailRecovery from './EmailRecovery';
import OneTimePassword from './OneTimePassword';
import SecurityQuestions from './SecurityQuestions';
import MultiStepProgressBar from './MultiStepProgressBar';
import PasswordReset from './PasswordReset';
import PasswordSuccess from './PasswordSuccess';
import { usePasswordRecovery } from './hooks';
import backArrowIcon from '../../img/arrow_back.svg';
import './PasswordRecovery.scss';

const PasswordRecovery = () => {
  const {
    currentStep,
    email,
    OTPExpiry,
    OTPLength,
    OTPAttempts,
    passwordRules,
    userDetails,
    skeletonLoader,
    setUserDetails,
    setEmail,
    nextStep,
    prevStep,
    accountLockedMessage,
  } = usePasswordRecovery();

  const BackButton = () => {
    return currentStep !== 1 && currentStep !== 5 ? (
      <div
        role={'button'}
        className="pe-auto"
        onClick={prevStep}
        tabIndex={0}
        onKeyPress={(event) => {}}
      >
        <img
          className="position-relative mr-3"
          src={backArrowIcon}
          alt="logo"
        />
      </div>
    ) : currentStep === 1 ? (
      <Link to="/admin">
        <img
          className="position-relative mr-3"
          src={backArrowIcon}
          alt="logo"
        />
      </Link>
    ) : null;
  };
  return (
    <Container className="password-recovery-container">
      <Row>
        <Col>
          {currentStep !== 5 && (
            <>
              <div className="page-header d-flex align-items-center">
                <BackButton />
                <h1 className="register-header mb-2">Reset Password</h1>
              </div>
              <MultiStepProgressBar currentStep={currentStep} />
            </>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="page-content-container">
            {currentStep === 1 && (
              <EmailRecovery
                handleEmailInput={setEmail}
                setUserDetails={setUserDetails}
                currentStep={currentStep}
                nextStep={nextStep}
                passwordRules={passwordRules}
                skeletonLoader={skeletonLoader}
              />
            )}

            {currentStep === 2 && (
              <SecurityQuestions
                email={email}
                userDetails={userDetails}
                currentStep={currentStep}
                nextStep={nextStep}
                prevStep={prevStep}
                accountLockedMessage={accountLockedMessage}
              />
            )}

            {currentStep === 3 && (
              <OneTimePassword
                email={email}
                currentStep={currentStep}
                nextStep={nextStep}
                prevStep={prevStep}
                OTPExpiry={OTPExpiry}
                OTPLength={OTPLength}
                OTPAttempts={OTPAttempts}
              />
            )}

            {currentStep === 4 && (
              <PasswordReset
                userDetails={userDetails}
                email={email}
                currentStep={currentStep}
                nextStep={nextStep}
                prevStep={prevStep}
                passwordRules={passwordRules}
                flowName={'Forgot Password'}
              />
            )}

            {currentStep === 5 && <PasswordSuccess currentStep={currentStep} />}
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default PasswordRecovery;
